var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Client "+_vm._s(_vm.clientInfo.displayname)+" est en cours de creation")])])}
var staticRenderFns = []

export { render, staticRenderFns }